import React from 'react';
import styles from './StatusDisplay.module.css';
import NavigationTooltip from '../NavigationTooltip';

// A simple representation of the status item, not a full circular progress bar yet.
const StatusItem = ({ emoji, altText, currentValue, maxValue, label, barColor, tooltipText, tooltipsEnabled = true }) => {
  const percentage = Math.round((currentValue / maxValue) * 100);
  
  return (
    <NavigationTooltip text={tooltipText} disabled={!tooltipsEnabled}>
      <div className={styles.statusItem}>
        <span className={styles.statusEmoji}>{emoji}</span>
        <div className={styles.statusBarContainer}>
          <div className={styles.statusBarBackground}>
            <div
              className={styles.statusBarFill}
              style={{ width: `${percentage}%`, backgroundColor: barColor }}
            />
          </div>
          <span className={styles.statusText}>{`${currentValue}/${maxValue}`}</span>
        </div>
      </div>
    </NavigationTooltip>
  );
};


const StatusDisplay = ({ health, mana, energy, tooltipsEnabled = true }) => {
  // Assuming health, mana, energy are objects like { current: 50, max: 100 }
  const healthPercentage = Math.round((health.current / health.max) * 100);
  const manaPercentage = Math.round((mana.current / mana.max) * 100);
  const energyPercentage = Math.round((energy.current / energy.max) * 100);

  return (
    <div className={styles.statusDisplayContainer}>
      <StatusItem
        emoji="❤️"
        altText="Health Icon"
        currentValue={health.current}
        maxValue={health.max}
        label="Health"
        barColor="#e74c3c" // Red for health
        tooltipText={`Health: ${health.current}/${health.max} (${healthPercentage}%) - Your life force. If it reaches 0, you'll pass out and wake up at home.`}
        tooltipsEnabled={tooltipsEnabled}
      />
      <StatusItem
        emoji="💧"
        altText="Mana Icon"
        currentValue={mana.current}
        maxValue={mana.max}
        label="Mana"
        barColor="#3498db" // Blue for mana
        tooltipText={`Mana: ${mana.current}/${mana.max} (${manaPercentage}%) - Your magical energy used for spells and enchantments.`}
        tooltipsEnabled={tooltipsEnabled}
      />
      <StatusItem
        emoji="⚡"
        altText="Energy Icon"
        currentValue={energy.current}
        maxValue={energy.max}
        label="Energy"
        barColor="#2ecc71" // Green for energy
        tooltipText={`Energy: ${energy.current}/${energy.max} (${energyPercentage}%) - Your stamina for activities. Low energy reduces efficiency. At 0, you collapse from exhaustion.`}
        tooltipsEnabled={tooltipsEnabled}
      />
    </div>
  );
};

export default StatusDisplay;